module.exports = __webpack_public_path__ + "img/hamberger-btn.5fef23aa.svg";